import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faBox,
  faFileAlt,
  faTruck,
  faDollarSign,
  faUsers,
  faShieldAlt,
  faChartBar,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const sections = [
  {
    title: "🌍 Product Listings",
    desc: "Browse or list women-led handmade products available for export with global ethical standards.",
    icon: faBox,
    action: "View Catalog",
    dummyData: ["Handwoven Sarees – Silk", "Beaded Jewelry Set", "Organic Herbal Teas", "Embroidered Cushions"],
  },
  {
    title: "📑 Compliance & Documents",
    desc: "Track and upload fair trade certificates, artisan licenses, and customs documents for exports.",
    icon: faFileAlt,
    action: "Upload Docs",
    dummyData: ["Fair Trade Certificate.pdf", "Artisan ID License.pdf", "Export Declaration.docx"],
  },
  {
    title: "🚚 Shipments & Logistics",
    desc: "Manage delicate transport options: Air, Sea, or Courier. Track live shipment status with care.",
    icon: faTruck,
    action: "Manage Shipments",
    dummyData: ["Parcel #ART12345 – In Transit", "Shipment ETA: 3 days", "Port: Mumbai"],
  },
  {
    title: "💱 Pricing & Forex",
    desc: "Check global craft prices, indicative shipping costs, and currency conversions for artisans.",
    icon: faDollarSign,
    action: "Check Rates",
    dummyData: [
      "Handwoven Sarees – $150/piece",
      "USD/INR: ₹84.5",
      "Shipping to USA: $25/parcel",
    ],
  },
  {
    title: "🤝 Trade Connect",
    desc: "Post product offers or requirements and connect with ethical global buyers and partners.",
    icon: faUsers,
    action: "Find Partners",
    dummyData: [
      "Buyer: EthicalThreads EU (50 Sarees)",
      "Seller: MahilaWeave India (Jewelry)",
      "Chat Room: Global Artisan Trade",
    ],
  },
  {
    title: "🛡️ Risk & Quality",
    desc: "See alerts on quality standards, packaging needs, and restricted market access for crafts.",
    icon: faShieldAlt,
    action: "View Alerts",
    dummyData: [
      "Alert: Fragile packaging check for Parcel #123",
      "Notice: EU ethical sourcing update",
    ],
  },
  {
    title: "📊 My Dashboard",
    desc: "View your posted exports, compliance status, active shipments, and artisan earnings.",
    icon: faChartBar,
    action: "Open Dashboard",
    dummyData: [
      "Active Exports: 8",
      "Pending Compliance: 2",
      "Earnings Generated: ₹2.5L",
    ],
  },
];

const MahilaMandiExportImport = () => {
  const [activeSection, setActiveSection] = useState(null);

  return (
    <div>
      <section className="py-4 px-6 md:px-8 bg-black min-h-screen">
        {/* Hero Section */}
        <div className="text-center mb-4 border border-green-400 py-4">
          <h1 className="text-xl md:text-2xl font-bold text-yellow-200 flex items-center justify-center gap-3">
            <FontAwesomeIcon icon={faGlobe} className="w-8 h-8 text-yellow-200" />
            MahilaMandi Women-Led Products Export Hub
          </h1>
          <p className="mt-4 text-white mx-auto">
            Connecting India’s women artisans to global markets with ethical trade, logistics, and compliance tools.
          </p>
        </div>

        {/* Sections Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mx-auto">
          {sections.map((s, idx) => (
            <div
              key={idx}
              className="flex flex-col justify-between rounded-2xl shadow-lg hover:shadow-xl transition border border-green-400 bg-black"
            >
              <div className="p-6 flex flex-col h-full">
                <div className="flex items-center gap-3 mb-4">
                  {/* <FontAwesomeIcon icon={s.icon} className="w-7 h-7 text-green-600" /> */}
                  <h3 className="text-lg font-semibold text-yellow-200">{s.title}</h3>
                </div>
                <p className="text-white text-sm flex-grow">{s.desc}</p>
                <button
                  onClick={() => setActiveSection(activeSection === idx ? null : idx)}
                  className="mt-4 bg-green-700 hover:bg-green-800 text-white rounded-xl py-2 w-full transition"
                >
                  {activeSection === idx ? "Hide Info" : s.action}
                </button>

                {/* Dummy Data Panel */}
                {activeSection === idx && (
                  <div className="mt-4 bg-green-50 border border-green-200 rounded-lg p-3 text-sm text-gray-700 animate-fade-in">
                    <div className="flex justify-between mb-2">
                      <span className="font-semibold text-green-800">
                        {s.title.split(" ")[0]} Snapshot
                      </span>
                      <FontAwesomeIcon
                        icon={faTimes}
                        className="text-red-500 cursor-pointer"
                        onClick={() => setActiveSection(null)}
                      />
                    </div>
                    <ul className="list-disc ml-5 space-y-1">
                      {s.dummyData.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black border border-green-300 text-white py-10 px-4 sm:px-6 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">
            &copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-green-400 transition">
              About
            </Link>
            <Link to="/privacy-policy" className="text-white hover:text-green-400 transition">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="text-white hover:text-green-400 transition">
              Terms of Use
            </Link>
            <Link to="/contact-us" className="text-white hover:text-green-400 transition">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MahilaMandiExportImport;